// extracted by mini-css-extract-plugin
export default {"PillarsCard_container":"PillarsCard_PillarsCard_container__CsUYN","PillarsCard_content":"PillarsCard_PillarsCard_content__sWtEt"};